// "Plan this city in the app" links (2026-10-30): the website's Trip Builder (andiamotravelapp.com) sends
// people to the web app for cities that have no Featured guide yet, e.g.
//   andiamoplaces.com/?build=Siena,Italy:2;Pisa,Italy:1&start=2026-11-02&src=trip-builder
// The app opens Build My Trip with those destinations filled in (one after another from the start date,
// default tomorrow), as a new guide. Nothing is built or saved until the person taps Create.
import { DateTime } from "luxon";
import { countries } from "../Data/Countries";
import { cleanDestination, MAX_TRIP_DAYS } from "./DestinationValidation";

const MAX_STOPS = 8;
const resolveCountry = (guess) => {
  const g = String(guess ?? "").trim().toLowerCase();
  return countries.find((c) => c.toLowerCase() === g) || null;
};

// ?build=City,Country:days;City,Country:days → { stops: [{ city, country, days }], start } or null
export function parseBuildLink(search) {
  let q;
  try { q = new URLSearchParams(search || ""); } catch (e) { return null; }
  const raw = q.get("build");
  if (!raw) return null;
  const stops = raw.split(";").slice(0, MAX_STOPS).map((part) => {
    const [place, daysRaw] = part.split(":");
    const [city, ...rest] = String(place || "").split(",").map((s) => s.trim());
    const days = Math.min(Math.max(parseInt(daysRaw, 10) || 1, 1), 14);
    return { city: (city || "").slice(0, 80), country: resolveCountry(rest.join(",")), days };
  }).filter((s) => s.city);
  if (!stops.length) return null;
  const start = /^\d{4}-\d{2}-\d{2}$/.test(q.get("start") || "") ? q.get("start") : null;
  return { stops, start };
}

// The parsed stops as Build My Trip destinations, back to back, capped at the app's trip length.
export function buildLinkDestinations(parsed, { today = DateTime.utc(), startH = 9, endH = 20 } = {}) {
  if (!parsed) return [];
  let day = parsed.start ? DateTime.fromISO(parsed.start, { zone: "utc" }) : today.setZone("utc").startOf("day").plus({ days: 1 });
  const out = [];
  let used = 0;
  parsed.stops.forEach((s, k) => {
    const days = Math.min(s.days, MAX_TRIP_DAYS - used);
    if (days <= 0) return;
    out.push(cleanDestination({ id: Date.now() + k, city: s.city, country: s.country || "", dateStart: day.set({ hour: startH }), dateEnd: day.plus({ days: days - 1 }).set({ hour: endH }) }));
    day = day.plus({ days });
    used += days;
  });
  return out;
}
